import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-soft bg-cream-2 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/47po7jix_final%20logo%20no%20background%20.png"
            alt="Carpe Diem Goa"
            className="h-24 w-auto object-contain -ml-2"
            data-testid="footer-logo"
          />
          <p className="mt-4 text-muted2 text-sm max-w-md leading-relaxed">
            A space to dare and explore the creative self that burns inside you — a launchpad
            for journeys of your own. Art gallery, ceramic studio, cafe, stage, art centre and a
            brand-new co-working space, all under one Goan roof.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Visit</div>
          <ul className="text-sm space-y-2 text-charcoal">
            <li>
              <a
                href="https://maps.app.goo.gl/HeXkvt2C4ekgL4tt5"
                target="_blank"
                rel="noreferrer"
                className="flex gap-2 items-start hover:text-terra transition"
                data-testid="footer-address-link"
              >
                <MapPin size={14} className="mt-1 text-sage"/> H. No. 81/2, Godinho House, Gomes Waddo, Majorda · South Goa 403713
              </a>
            </li>
            <li>
              <a href="tel:+919822580152" className="flex gap-2 items-start hover:text-terra transition" data-testid="footer-phone-link">
                <Phone size={14} className="mt-1 text-sage"/> +91 98225 80152 · WhatsApp
              </a>
            </li>
            <li>
              <a href="mailto:info@carpediemgoa.com" className="flex gap-2 items-start hover:text-terra transition" data-testid="footer-email-link">
                <Mail size={14} className="mt-1 text-sage"/> info@carpediemgoa.com
              </a>
            </li>
            <li className="flex gap-2 items-start"><Clock size={14} className="mt-1 text-sage"/> Wed–Sun · 10 AM – 7 PM<br/><span className="text-muted2 text-xs">Cafe last orders 6:30 PM · Closed on public holidays</span></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Spaces</div>
          <ul className="text-sm space-y-2">
            <li><Link to="/gallery" className="link-hover">Art Gallery</Link></li>
            <li><Link to="/art-centre" className="link-hover">Art Centre</Link></li>
            <li><Link to="/ceramic" className="link-hover">Ceramic Studio</Link></li>
            <li><Link to="/cafe" className="link-hover">Cafe</Link></li>
            <li><Link to="/stage" className="link-hover">Stage</Link></li>
            <li><Link to="/coworking" className="link-hover">Co-working</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Programme</div>
          <ul className="text-sm space-y-2">
            <li><Link to="/events" className="link-hover">All Events</Link></li>
            <li><Link to="/artists" className="link-hover">Artists</Link></li>
            <li><Link to="/gallery/buy" className="link-hover">Buy Art</Link></li>
            <li><Link to="/contact" className="link-hover">Contact</Link></li>
            <li><Link to="/admin/login" className="link-hover text-muted2">Admin</Link></li>
            <li><a href="https://instagram.com/carpediemgoa" target="_blank" rel="noreferrer" className="link-hover inline-flex items-center gap-1.5" data-testid="footer-instagram"><Instagram size={14}/>@carpediemgoa</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-soft">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-muted2 gap-3">
          <div>© {new Date().getFullYear()} Carpe Diem Goa. Seize the Day.</div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 justify-center">
            <Link to="/terms" className="link-hover" data-testid="footer-terms">Terms</Link>
            <Link to="/privacy" className="link-hover" data-testid="footer-privacy">Privacy</Link>
            <Link to="/refund-policy" className="link-hover" data-testid="footer-refund">Refund &amp; Cancellation</Link>
            <Link to="/shipping-policy" className="link-hover" data-testid="footer-shipping">Delivery</Link>
          </div>
          <div>Built with care · Majorda</div>
        </div>
      </div>
    </footer>
  );
}
